module.exports = __webpack_public_path__ + "media/applications/assets/images/size-info/skirt-24a545cce5ea54549d6c8147d761fab9.png";